import { forwardRef } from 'react';
import { TextField } from "@mui/material";

const DatePickerInput = forwardRef(({ value, onClick, placeholder, ...props }, ref) => (
  <TextField
    {...props}
    inputRef={ref}
    value={value}
    onClick={onClick}
    placeholder={placeholder}
    size="small"
    fullWidth
  />
));

export default DatePickerInput;
